import { AdvancedSearchData } from '@/components/search/types';
import {
  searchCriteriaForEenheden,
  searchCriteriaForIds,
  searchCriteriaForTreinnummers,
} from '@/components/search/v1/utils/helpers';
import { Signaal } from '@/types/Signalen';

export function mapCriteriaVoorSignalenToevoegen(signalen: Signaal[]): AdvancedSearchData[] {
  const criteriaWerklijnIds: string[] = [];
  const criteriaEenheidnummers: string[] = [];
  const criteriaTreinnummers: string[] = [];
  const criteriaTreindatums: string[] = [];
  const criteria: AdvancedSearchData[] = [];
  signalen.forEach((signaal) => {
    switch (signaal.type) {
      case 'WisselenSignaal':
      case 'VerwijderdeClaimSignaal':
      case 'NieuweClaimSignaal':
      case 'GewijzigdeInzetSignaal':
        criteriaWerklijnIds.push(signaal.betrokkenWerklijn.id);
        break;
      case 'VerzwakSignaal':
      case 'VersterkenSignaal':
        signaal.alleBetrokkenWerklijnen.forEach((value) => criteriaWerklijnIds.push(value.id));
        break;
      case 'InzetbaarheidSignaal':
      case 'InregelingSignaal':
        criteriaEenheidnummers.push(signaal.eenheidNummer);
        break;
      case 'VerlengenSignaal':
      case 'OmleidingSignaal':
      case 'OpheffenSignaal':
        signaal.betrokkenWerklijnen.forEach((value) => criteriaWerklijnIds.push(value.id));
        break;
      case 'NieuweBewegingSignaal':
        criteriaTreinnummers.push(String(signaal.bewegingSleutel.treinnummer));
        if (!criteriaTreindatums.includes(signaal.bewegingSleutel.treindatum)) {
          criteriaTreindatums.push(signaal.bewegingSleutel.treindatum);
        }
        break;
    }
  });

  if (criteriaWerklijnIds.length > 0) {
    criteria.push(searchCriteriaForIds(criteriaWerklijnIds));
  }

  if (criteriaEenheidnummers.length > 0) {
    criteria.push(searchCriteriaForEenheden([...new Set(criteriaEenheidnummers)]));
  }

  if (criteriaTreinnummers.length > 0 && criteriaTreindatums.length > 0) {
    criteria.push(searchCriteriaForTreinnummers([...new Set(criteriaTreinnummers)], [...new Set(criteriaTreindatums)]));
  }
  return criteria;
}
